export enum InternetPackageActionTypes {
    FETCH_INTERNET_PACKAGE_TYPES = '@@internet/FETCH_INTERNET_PACKAGE_TYPES',
    SET_INTERNET_PACKAGE_TYPES = '@@internet/SET_INTERNET_PACKAGE_TYPES',
    FETCH_ERROR = '@@internet/FETCH_ERROR',
    FETCH_MODAL = '@@internet/FETCH_MODAL'
}

export interface InternetPackageStateInterface {
    readonly internetPackage: object,
    readonly loading: boolean,
    readonly modal: boolean
}
